import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { IEntityClassificationData } from '.';
import { MAIN_THEME } from '@styles';

const useStyles = makeStyles()(() => ({
  classification: {
    minHeight: 24,
    minWidth: 'fit-content',
    padding: '0 5px',
    width: 70,
    margin: 'auto',
    font: 'normal',
    fontSize: MAIN_THEME.fontSize.xs,
    lineHeight: '14px',
    fontFamily: MAIN_THEME.font.regular,
    borderRadius: '5px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
  },
}));

const EntityInfoClassification: React.FC<IEntityClassificationData> = ({
  classifications,
  value,
}) => {
  const { classes } = useStyles();

  return classifications && classifications[value] ? (
    <div
      className={classes.classification}
      style={{ backgroundColor: classifications[value].color }}
    >
      {classifications[value].text}
    </div>
  ) : (
    <></>
  );
};

export default EntityInfoClassification;
